export default "__VITE_ASSET__CkxdWdQC__"